import { render, staticRenderFns } from "./MySessions.vue?vue&type=template&id=595f35d1"
import script from "./MySessions.vue?vue&type=script&lang=js"
export * from "./MySessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports